/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popStarDeposit.vue?vue&type=template&id=41db77b0&scoped=true"
import script from "./popStarDeposit.vue?vue&type=script&lang=js"
export * from "./popStarDeposit.vue?vue&type=script&lang=js"
import style0 from "./popStarDeposit.vue?vue&type=style&index=0&id=41db77b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41db77b0",
  null
  
)

export default component.exports